import { GitForkIcon, GitlabLogoIcon } from '@phosphor-icons/react';

import { SettingsSection } from '@/features/settings/components/SettingsSection';
import { settingsBase } from '@/features/settings/components/nav-config';
import { useSpace } from '@/contexts/space-context';
import { GitHubConnectionCard } from '@/features/integrations/components/GitHubConnectionCard';
import { ComingSoonProviderCard } from '@/features/integrations/components/ComingSoonProviderCard';
import { RepositoriesManager } from '@/features/repositories/components/RepositoriesManager';

export function SourceControlSection() {
  const { teamId } = useSpace();

  return (
    <>
      <SettingsSection
        title="Providers"
        description="Once a provider is connected, you can start a workspace from any branch of its repositories."
      >
        <div className="flex flex-col gap-2.5">
          <GitHubConnectionCard redirectTo={`${settingsBase(teamId)}/integrations/source-control`} />
          <ComingSoonProviderCard
            name="GitLab"
            icon={<GitlabLogoIcon size={22} weight="duotone" className="text-fg-secondary" />}
            description="Start workspaces from any branch of your GitLab projects."
          />
          <ComingSoonProviderCard
            name="Bitbucket"
            icon={<GitForkIcon size={22} weight="duotone" className="text-fg-secondary" />}
            description="Start workspaces from any branch of your Bitbucket repositories."
          />
        </div>
      </SettingsSection>

      <RepositoriesManager />
    </>
  );
}
